import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { BaseDataService, BaseTabsUpdateComponent, TabsContainerService, UserService } from 'yt-ng-framework';
import { OrgJedDefgini } from './orgjeddefgini';

@Component({
  selector: 'yt-orgjeddefgini-tab-update',
  templateUrl: './orgjeddefgini-tab-update.component.html'
})
export class OrgjeddefginiTabUpdateComponent extends BaseTabsUpdateComponent<OrgJedDefgini> implements OnInit {

  constructor(
    protected activatedRoute: ActivatedRoute,
    protected tabsContainerService: TabsContainerService<OrgJedDefgini>,
    protected baseDataService: BaseDataService,
    protected userService: UserService
  ) {
    super(activatedRoute, tabsContainerService, baseDataService, userService);
  }

  ngOnInit() {
    super.ngOnInit();
  }

}
